import React from 'react';
import styled from 'styled-components';
import useContentAsociacionUsuariosFunciones from '../hooks/parameter/useContentAsociacionUsuariosFunciones.js';

const DivContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;

  p {
    text-align: center;

    img {
      margin-top: 2.5rem;
      width: 100% !important;
    }
  }
`;

export const PageFunciones = () => {
  window.scroll(0, 0);
  const { asociacionUsuariosFunciones } =
    useContentAsociacionUsuariosFunciones();
  const bodyHTML =
    asociacionUsuariosFunciones.length > 0 &&
    asociacionUsuariosFunciones[0].texto_completo;

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <DivContainer id='contBodyHTML'>
          <p dangerouslySetInnerHTML={{ __html: bodyHTML }} />
        </DivContainer>
      </div>
    </>
  );
};
